import { Link } from 'react-router-dom';
import { Settings, Image, FileText, Mail, Package, ArrowRight } from 'lucide-react';
import { useAuth } from './AuthContext';

const cards = [
  {
    to: '/admin/config',
    title: 'Konfigurasi Site',
    desc: 'Nama brand, logo, WhatsApp, dan nomor hotline.',
    icon: Settings,
  },
  {
    to: '/admin/banners',
    title: 'Banner Hero',
    desc: 'Slide carousel di halaman beranda.',
    icon: Image,
  },
  {
    to: '/admin/catalog',
    title: 'Katalog Produk',
    desc: 'Kelola kategori, subkategori, dan produk.',
    icon: Package,
  },
  {
    to: '/admin/about',
    title: 'Halaman Tentang',
    desc: 'Teks tentang, visi, dan misi PowerX.',
    icon: FileText,
  },
  {
    to: '/admin/contact',
    title: 'Halaman Kontak',
    desc: 'Alamat kantor, hotline, email, dan WhatsApp.',
    icon: Mail,
  },
];

export default function AdminDashboard() {
  const { admin } = useAuth();
  return (
    <div data-testid="admin-dashboard">
      <p className="text-xs tracking-[0.25em] text-px-red font-semibold mb-3">
        DASHBOARD
      </p>
      <h1 className="font-display text-4xl font-bold text-neutral-900 mb-2">
        Selamat datang, {admin?.name || 'Admin'}.
      </h1>
      <p className="text-neutral-600 mb-10">
        Pilih menu di bawah untuk mengelola konten website Anda.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {cards.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="group bg-white rounded-2xl p-6 border border-neutral-200 hover:border-neutral-900 hover:shadow-md transition-all flex items-start gap-4"
          >
            <div className="w-12 h-12 rounded-xl bg-red-50 flex items-center justify-center flex-shrink-0">
              <c.icon className="w-6 h-6 text-px-red" />
            </div>
            <div className="flex-1">
              <h3 className="font-display text-lg font-bold text-neutral-900 mb-1">
                {c.title}
              </h3>
              <p className="text-sm text-neutral-600">{c.desc}</p>
            </div>
            <ArrowRight className="w-5 h-5 text-neutral-400 mt-2 group-hover:translate-x-1 transition-transform" />
          </Link>
        ))}
      </div>
    </div>
  );
}
